// extracted by mini-css-extract-plugin
export default {"elevation-button":"Button_elevation-button__Di7eE"};